export default __webpack_public_path__ + "static/media/cegah (5).7c1c7bbd.png";